document.addEventListener('DOMContentLoaded', function () {

  // ---- Lazy tab panels: hydrate a tab's product grid only when that tab becomes active ----
  const hydrateTabItem = function (tabItem) {
    const placeholder = tabItem.querySelector(':scope > [data-lazy-tab-content], [data-lazy-tab-content]');
    if (!placeholder) return;
    const template = placeholder.querySelector('template');
    if (template) {
      const content = template.content.cloneNode(true);
      placeholder.appendChild(content);
      placeholder.removeAttribute('style');
      template.remove();
    }
  };

  const tabObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName === 'tab-selected' && m.target.hasAttribute('tab-selected')) {
        hydrateTabItem(m.target);
      }
    });
  });

  // Finds every [tab-item] inside `root` (root itself included) and wires it up.
  // Called once for the whole document on load, and again for any content that
  // gets hydrated later out of a lazy section (since template content isn't
  // part of the live DOM until it's cloned in).
  const setupTabItemsWithin = function (root) {
    const tabItems = root.matches && root.matches('[tab-item]')
      ? [root, ...root.querySelectorAll('[tab-item]')]
      : root.querySelectorAll('[tab-item]');

    tabItems.forEach(function (tabItem) {
      if (tabItem.hasAttribute('tab-selected')) {
        hydrateTabItem(tabItem); // already-active tab (normally index 0, rendered eagerly server-side, so this is a safety no-op)
      }
      tabObserver.observe(tabItem, { attributes: true, attributeFilter: ['tab-selected'] });
    });
  };

  // ---- Lazy sections: defer whole sections until they scroll near the viewport ----
  const sectionObserver = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const placeholder = entry.target;
        const template = placeholder.querySelector(':scope > template');
        if (template) {
          const content = template.content.cloneNode(true);
          placeholder.appendChild(content);
          placeholder.removeAttribute('style'); // يشيل min-height المؤقت
          template.remove();
          setupTabItemsWithin(placeholder); // catch any tabs that just became real DOM
        }
        obs.unobserve(placeholder);
      }
    });
  }, {
    rootMargin: '400px 0px', // يبدأ التحميل قبل ما يوصل الشاشة بـ 400px
    threshold: 0
  });

  document.querySelectorAll('[data-lazy-section]').forEach(function (el) {
    sectionObserver.observe(el);
  });

  // Wire up any tabs that are already live in the DOM (not inside a lazy section)
  setupTabItemsWithin(document);
});
